<template>
  <div id="demo-basic-card">
    <div id="dashboard-analytics">
      <div class="vx-row mt-4">
        <div class="vx-card p-6">
          <div class="vx-row">
            <div class="vx-col w-full title-warning ">
                <span>{{isUpdate ? $t('warning.updateRulesWarning') : $t('warning.createRulesWarning')}}</span>
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col md:w-1/3 w-full mt-2 p-4">
              <div class="w-full p-4 pr-8" style="background: rgba(235, 235, 235, .25)">
                  <div class="w-full mt-2">
                    <span class="label-warning">{{ $t('warning.warningName') }}: </span>
                    <span style="color:red">*</span>
                  </div>
                  <div class="w-full mt-2">
                    <vs-input name= "name" class="w-full" v-model="warning.name" :placeholder="$t('warning.warningName')" data-vv-validate-on="blur" v-validate ="'required'"></vs-input>
                    <span class="text-danger text-sm mt-1">
                      {{errors.first("name")}}
                    </span>
                  </div>

                  <!-- <div class="w-full mt-2">
                      <span class="label-warning">Loại báo cáo: *</span>
                  </div> -->
                  <!-- <div class="w-full mt-2">
                      <vs-input class="w-full" v-model="warning.name" placeholder= "Chọn loại báo cáo"></vs-input>
                  </div> -->

                  <div class="w-full mt-4">
                    <div class="vx-row m-0 mt-2 vx-card card-filter">
                      <div class="component w-full p-4">
                        <span class="label-warning">{{ $t('warning.filterSmart') }}</span>
                      </div>
                      <div class="md:w-8/12 pl-4">
                        <span class="content-active ">Ngưng cảnh báo với những tin bài có nội dung giống với những tin bài đã cảnh báo trước đó</span>
                      </div>
                      <div class="md:w-4/12 mt-2 p-4">
                        <vs-switch class="float-right" v-model="warning.activeWarning"></vs-switch>
                      </div>
                    </div>
                  </div>

                  <div class="w-full mt-4">
                    <div class="w-full">
                      <span class="label-warning">Email</span>
                    </div>
                    <div class="w-full flex mt-4" v-for="(email, indexEmail) in optionEmails" :key="indexEmail">
                      <vs-checkbox v-model="email.check" @click="getTypeEmail(email)"></vs-checkbox>
                      <span class="select-mail">{{email.label}}</span>
                    </div>
                  </div>
                  <div class="w-full mt-4">
                    <div class="w-full">
                      <span class="label-warning">{{ $t('warning.sendMail') }}: </span>
                      <span style="color:red">*</span>
                    </div>
                    <div class="w-full mt-2" v-for="(email, indexEmail) in notify.emails" :key="indexEmail">
                      <vs-input name="email" class="w-full" v-model="email.email" :placeholder="'email' +(indexEmail + addIndex)+ '@domain.com'"></vs-input>
                      <span class="text-danger text-sm mt-1">
                        {{errors.first("email")}}
                      </span>
                    </div>
                    <div class="w-full mt-4 flex">
                      <vs-button style="z-index:1" icon="icon-plus" icon-pack="feather" type="border" @click="addNewRecord(addIndex)">{{ $t('warning.addEmail') }}</vs-button>
                      <feather-icon style="margin-left: 10px; vertical-align: middle" icon="TrashIcon"
                        svgClasses="h-6 w-6 hover:text-primary cursor-pointer" title="Xóa từ khóa"
                        @click="confirmDeleteEmail(addIndex)"/>
                    </div>
                  </div>
              </div>
            </div>

            <div class="vx-col md:w-2/3 w-full mt-2 p-4">
              <div class="vx-row pl-6 pr-6">
                  <div class="w-full">
                  <span class="label-warning">{{ $t('warning.rulesWarning') }}: </span>
                  <feather-icon icon="HelpCircleIcon" class="icon-help" ></feather-icon>
                  </div>
                  <div class="w-full p-4 mt-2" style="background: rgba(235, 235, 235, .25);">
                      <div class="vx-row space-between">
                          <div class="vx-col md:w-5/12 w-full">
                              <span class="label-warning">{{ $t('warning.project') }}: </span>
                              <span style="color:red">*</span>
                              <v-select style="width: 250px"
                              class="text-size w-full mt-2"
                              :options ="topicGroups"
                              v-model="selectedTopicGroup"
                              @input="filterTopicByTopicGroupId"
                              name="project"
                              data-vv-validate-on="input|blur"
                              v-validate ="'required'"
                              />
                              <span class="text-danger text-sm mt-1">
                                {{errors.first("project")}}
                              </span>
                          </div>

                          <div class="vx-col md:w-6/12 w-full mr-4">
                              <span class="label-warning">{{ $t('warning.topic') }}:</span>
                              <v-select style="width: 250px"
                              class="text-size w-full mt-2"
                              :options ="topics"
                              v-model="selectedTopic"
                              />
                          </div>
                      </div>
                  </div>
              </div>

              <div class="vx-row mt-6 pl-6 pr-6">
                <div class="w-full">
                <span class="label-warning">{{ $t('warning.condition') }}: </span>
                <feather-icon icon="HelpCircleIcon" class="icon-help" ></feather-icon>
                </div>
                <div class="w-full p-4 mt-2" style="background: rgba(235, 235, 235, .25);">
                  <div class="vx-row space-between">
                    <div class="vx-col md:w-5/12 w-full">
                      <span class="label-warning">{{ $t('warning.project') }}: </span>
                      <span style="color:red">*</span>
                      <v-select
                      class="text-size w-full mt-2"
                      :options ="optionWarningTypes"
                      v-model="selectedWarningType"
                      @input="checkOptionWhenSelected"
                      name="conditionProject"
                      data-vv-validate-on="input|blur"
                      v-validate ="'required'"
                      />
                      <span class="text-danger text-sm mt-1">
                        {{errors.first("conditionProject")}}
                      </span>
                    </div>

                    <div class="vx-col md:w-6/12 w-full mr-4">
                      <span class="label-warning">{{ $t('warning.condition') }}: </span>
                      <span style="color:red">*</span>
                      <div class="vx-row">
                        <div class="vx-col md:w-1/2 w-full">
                          <v-select
                          class="text-size w-full mt-2"
                          :options ="optionConditions"
                          v-model="selectedCondition"
                          @input="checkOptionWhenSelectedCondition"
                          name="condition"
                          data-vv-validate-on="blur"
                          />
<!--                          <span class="text-danger text-sm mt-1">-->
<!--                            {{errors.first("condition")}}-->
<!--                          </span>-->
                        </div>
                        <div class="vx-col md:w-1/2 w-full">
                          <v-select
                          class="text-size w-full mt-2"
                          :options ="optionPosts"
                          v-model="selectedValueData"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div><div class="vx-row mt-6 pr-6 pl-6">
                <div class="w-full">
                <span class="label-warning">{{ $t('warning.source') }}: </span>
                <feather-icon icon="HelpCircleIcon" class="icon-help" ></feather-icon>
                </div>
                <div class="w-full p-4 mt-2" style="background: rgba(235, 235, 235, .25);">
                  <div class="vx-row">
                    <div class="vx-col md:w-3/12 w-full mt-2 flex " v-for="(source, indexSource) in optionSources" :key="indexSource" style="align-items: center">
                      <vs-checkbox v-model="source.check" @click="getBeanTypeSource(source)"></vs-checkbox>
                      <span class="select-source">{{source.label}}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="vx-row">
            <div class="component w-full">
              <vs-button class="float-right mr-6" @click="saveChange" :disabled="!validateForm">{{isUpdate ? $t('warning.updateWarning') : $t('warning.createWarning')}}</vs-button>
              <vs-button type="border" class="mr-2 float-right" @click="$router.push('/user/warning-v2')">{{ $t('warning.cancel') }}</vs-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import vSelect from 'vue-select'
export default {
  components: {
      vSelect
  },
  data(){
    return {
      addIndex: 1,
      optionEmails: [
        {label: 'Gửi email', value: 0, check: false},
        {label: 'Thông báo đẩy (Web push notification)', value: 1, check: false}
      ],
      optionSources: [
        {label: this.$t('warning.allSources'), value: null, check: false},
        {label: 'Facebook', value: [104,105], check: false},
        {label: 'Blog và Website', value: [113], check: false},
        {label: this.$t('warning.news'), value: [101], check: false},
        {label: 'Youtube', value: [106, 107], check: false},
        {label: this.$t('warning.forum'), value: [111, 112], check: false}
      ],
      optionWarningTypes: [
        {label: this.$t('warning.anyPost'), value: 0},
        {label: this.$t('warning.negativeContent') + ' (' + this.$t('warning.totalCollectedPost') + ')', value: 1},
        {label: this.$t('warning.positiveContent') + ' (' + this.$t('warning.totalCollectedPost') + ')', value: 2},
        {label: this.$t('warning.neutralContent') + ' (' + this.$t('warning.totalCollectedPost') + ')', value: 3},
        {label: this.$t('warning.share') + ' (' + this.$t('warning.ofAArticle') + ')', value: 4},
        {label: this.$t('warning.comment') + ' (' + this.$t('warning.ofAArticle') + ')', value: 5}
      ],
      optionConditions: [],
      optionPosts: [],
      topicGroupId:null,
      topicId:null,
      topicGroups: [],
      topics: [],
      refreshTopicDatas: [],
      warning:{
        id: null,
        name: null,
        activeWarning: true,
        sendMail:false,
        dataType: null,
        email: null,
        emailType: [],
        emailWebPush: null,
        source: [],
        sourceType: null,
        topicGroupId: null,
        topicId: null,
        userId: null,
        warningTypeSetting: null
      },
      notify: {
        emails:[
          {email:""}
        ],
        notifySelected: false
      },
      isUpdate: false
    }
  },
  computed: {
    validateForm: function(){
      return !this.errors.any();
    },
    selectedTopic: {
      get(){
        let object = this.topics.find(topic => topic.value == this.warning.topicId);
        if (!object) return;
        return {
          label: object.label,
          value: this.warning.topicId
        }
      },
      set(object) {
        this.warning.topicId = object ? object.value : null;
      }
    },
    selectedTopicGroup: {
      get(){
        let object = this.topicGroups.find(el => el.value == this.warning.topicGroupId);
        if (!object) return;
        return {
          label: object.label,
          value: this.warning.topicGroupId
        }
      },
      set(object){
        this.warning.topicGroupId = object ? object.value : null;
      }
    },
    selectedWarningType: {
      get() {
        let object = this.optionWarningTypes.find(warning => warning.value  == this.warning.warningTypeSetting);
        if (!object) return;
        return {
          label: object.label,
          value: this.warning.warningTypeSetting
        }
      },
      set(object) {
        this.warning.warningTypeSetting = object ? object.value : null;
      }
    },
    selectedCondition: {
      get(){
        let object = this.optionConditions.find(el => el.value == this.warning.conditionWarningType);
        if (!object) return;
        return {
            label: object.label,
            value: this.warning.conditionWarningType
        }
      },
      set(object){
        this.warning.conditionWarningType = object ? object.value : null;
      }
    },
    selectedValueData: {
      get(){
        let object = this.optionPosts.find(post => post.value  == this.warning.dataType);
        if (!object) return;
        return {
          label: object.label,
          value: this.warning.dataType
        }
      },
      set(object) {
        this.warning.dataType = object ? object.value : null
      }
    }
  },
  methods: {
    getTypeEmail: function(item) {
      if(!item.check) this.warning.emailType.push(item.value)
      else {
        let index = this.warning.emailType.indexOf(item.value);
        if (index > -1) this.warning.emailType.splice(index, 1);
      }
    },
    getBeanTypeSource: function(item){
      if (item.label.includes(this.$t('warning.allSources')) && !item.check) {
        let index = 0;
        this.optionSources.forEach(el => {
          if (index > 0){
            el.check = true;
            el.value.map(value => this.warning.source.push(value))
          }
          index++;
        });
      }else if (item.label.includes(this.$t('warning.allSources')) && item.check){
        let index = 0;
        this.optionSources.forEach(el => {
          if (index == 0) {
            el.check = false;
          }
          el.check = !el.check
          index++;
        })
      }
      else if (!item.check && item.value) {
        item.check = false;
        item.value.map(el => this.warning.source.push(el))
        if (this.optionSources.filter(el => el.check).length == 4) this.optionSources[0].check = true;
      }
      else {
        item.check = true;
        if (item.value) {
          item.value.map(value => {
            let index = this.warning.source.indexOf(value)
            if (index > -1){
              this.warning.source.splice(index, 1);
            }
          })
        }
        if (this.optionSources.filter(el => el.check).length !=4 ) this.optionSources[0].check = false;
      }
    },
    validateEmail: function(email) {
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    },
    async saveChange(evt){
      evt.preventDefault();
      let validate = await this.$validator.validateAll();
      if (!validate || this.notify.emails[0].email.length == 0) {
        return this.$vs.notify({
          text: this.$t('warning.doNotFullInfomation'),
          icon:'icon-alert-circle',
          iconPack: 'feather',
          color:'danger'
        })
      };
      let checkListEmail = true;
      if (this.notify.emails[0].email.length > 0) {
        this.notify.emails.forEach(email => {
          let checkEmail = this.validateEmail(email.email);
          if (!checkEmail) {
            checkListEmail = false;
            return this.$vs.notify({
              text: this.$t('warning.emailInvalid') + email.email,
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
            })
          }
        })
      }
      if (!checkListEmail) return;
      let email = '';
      this.notify.emails.map(el => {
        if (email.length > 0) email = email + ', ' + el.email
        else email = el.email
      })
      const payload = {
        id: this.warning.id,
        name: this.warning.name,
        activeWarning: this.warning.activeWarning,
        email: email,
        emailType: this.warning.emailType.toString(),
        topicGroupId: this.warning.topicGroupId,
        topicId: this.warning.topicId,
        warningTypeSetting: this.warning.warningTypeSetting,
        conditionWarningType: this.warning.conditionWarningType,
        source: this.warning.source.toString(),
        sourceType: 0,
        sourceTypeAction: 0,
        frequencyType: 0,
        label: 0,
        dataType: this.warning.dataType
      }
      if (this.isUpdate) payload.id = this.$route.query.id;
      this.$vs.loading();
      let path = this.isUpdate ? '/warning/update-warning' : '/warning/create-warning';
      this.$processor.post(path, payload).then(() => {
        this.$vs.loading.close();
        this.$router.push('/user/warning-v2')
        return this.$vs.notify({
            text: `${isUpdate ? this.$t('warning.updateWarning') : this.$t('warning.createWarning')}` + this.$t('warning.success'),
            icon: 'icon-alert',
            iconPack: 'feather',
            color: 'primary'
        })
      }).catch((err) => {
        return this.$vs.notify({
          text: err.response.data.message || err.response.data.error_description || err.response.data.error,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        });
      })

    },
    filterTopicByTopicGroupId: function(){
        this.topics = this.refreshTopicDatas;
        this.topics = this.topics.filter(topic => topic.topicGroupId == this.warning.topicGroupId);
    },
    checkOptionWhenSelectedCondition: function(){
        this.optionPosts = [];
        let arrCondition = [0, 1, 2, 3 , 4, 5, 6]
        if (this.warning.warningTypeSetting == 0 && arrCondition.includes(this.warning.conditionWarningType)) {
            let options = [
                {label: 'Một bài', value: 1},
                {label: 'Gộp 5', value: 5},
                {label: 'Gộp 10', value: 10},
                {label: 'Gộp 20', value: 20},
                {label: 'Gộp 50', value: 50}
            ]
            this.optionPosts = options;
        }
        let arrWarning = [1, 2, 3]
        if (arrWarning.includes(this.warning.warningTypeSetting) && arrCondition.includes(this.warning.conditionWarningType)) {
            for (let i = 0; i <= 100; i++) {
                let element = {
                    label: '',
                    value: null
                }
                if (i%5 == 0 && i > 0) {
                    element.label = i + '%';
                    element.value = i;
                    this.optionPosts.push(element);
                }
            }
        }
        let arrCommentAndShare = [4, 5]
        if (arrCommentAndShare.includes(this.warning.warningTypeSetting) && arrCondition.includes(this.warning.conditionWarningType)) {
            let options = [
                {label: '100', value: 100},
                {label: '500', value: 500},
                {label: '1.000', value: 1000},
                {label: '2.500', value: 2500},
                {label: '5.000', value: 5000},
                {label: '10.000', value: 10000}
            ]
            this.optionPosts = options;
        }
    },
    checkOptionWhenSelected: function(){
        this.optionConditions = [];
        this.optionPosts = [];
        if (this.warning.warningTypeSetting == 0){
            let options = [
                {label: this.$t('warning.positive'), value: 0},
                {label: this.$t('warning.negative'), value: 1}
            ]
            this.optionConditions = options;
        }
        let arr = [1, 2, 3]
        if (arr.includes(this.warning.warningTypeSetting)) {
            let options = [
                {label: this.$t('warning.equal'), value: 2},
                {label: this.$t('warning.lessThan'), value: 3},
                {label: this.$t('warning.lessThanOrEqual'), value: 4},
                {label: this.$t('warning.moreThan'), value: 5},

            ]
            this.optionConditions = options;
        }
        let arrOther = [4, 5]
        if (arrOther.includes(this.warning.warningTypeSetting)) {
            let options = [
                {label: this.$t('warning.moreThanOrEqual'), value: 6}
            ]
            this.optionConditions = options;
        }
    },
    getTopicGroups: function(){
        this.$business.post('/topic-group/find-by-conditions',{}).then((res) =>{
            if(res.status ==200){
                this.topicGroups = res.data;
                if(this.topicGroups.length > 0){
                    this.topicGroups = this.topicGroups.map(el =>{
                    if(el.groupName && el.groupName.length > 25){
                        el.groupName = el.groupName.slice(0,25) + '...';
                    }
                    return {
                        label:el.groupName,
                        value:el.id
                    }
                    });
                }
            }
        }).catch()
    },
    getTopics() {
    let conditions = {};
    this.$business
        .post("/topic/find-by-conditions", conditions)
        .then(topics => {
        this.$business.post(`share-topic/get-all-share`,{}).then((res) => {
            this.topics = [...topics.data, ...res.data].map(el => {
                return {
                    label: el.topicName,
                    value: el.id,
                    topicGroupId: el.topicGroupId
                }
            });
            this.refreshTopicDatas = this.topics;
        }).catch(() => {})

        })
        .catch(err => {});
    },
    addNewRecord: function(emailIndex){
      this.addIndex++;
        const payload = {
            email: ''
        }
        this.notify.emails.splice(this.addIndex, 0, payload);
    },
    confirmDeleteEmail (index) {
      if (this.notify.emails.length == 1) {
        return this.$vs.notify({
          text: this.$t('projectAndTopic.textTheme4'),
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        });
      }
      this.deleteEmail();
    },
    deleteEmail: function(){
      this.notify.emails.splice(this.addIndex - 1, 1);
      if (this.addIndex > 1) this.addIndex--;
    },
    findByIdWarning: function(){
        let id = this.$route.query.id
        if (id) {
          this.$processor.get(`/warning/find-by-id/${id}`).then((res) => {
            this.isUpdate = true;
            let warning = res.data;
            this.warning.name = warning.name;
            this.warning.activeWarning = warning.activeWarning;
            this.warning.sendMail = warning.emailType;
            this.warning.warningTypeSetting = warning.warningTypeSetting;
            this.warning.topicGroupId = warning.topicGroupId;
            this.warning.topicId = warning.topicId;
            this.warning.conditionWarningType = warning.conditionWarningType;
            this.warning.dataType = warning.dataType;
            let source = warning.source.split(',');
            if (source.length == 8) {
                this.optionSources.forEach(el => el.check = true);
            }
            let listSources = warning.source.split(',');
            listSources = listSources.map(el => parseInt(el));
            listSources.forEach(el => {
                this.optionSources.forEach(source => {
                    if (source.value && source.value.includes(el)) {
                        source.check = true;
                        this.warning.source.push(el);
                    }
                })
            })
            let emailTypes = warning.emailType.split(',');
            emailTypes  = emailTypes.map(el => parseInt(el));
            emailTypes.forEach(el => {
                this.optionEmails.forEach(email => {
                    if (email.value == el) {
                        email.check = true;
                        this.warning.emailType.push(el)
                    }
                })
            })
            let listEmails = warning.email.split(',');
            listEmails = listEmails.map(email => {
                return {
                    email: email
                }
            })
            this.notify.emails = listEmails;
            this.checkOptionWhenSelected();
            this.checkOptionWhenSelectedCondition();
          })
        }
    },
    initScreen(){
      this.checkOptionWhenSelected();
      this.findByIdWarning();
      this.getTopicGroups();
      this.getTopics();
    },
    refreshI18n: function(){
        this.optionWarningTypes = [
            {label: this.$t('warning.anyPost'), value: 0},
            {label: this.$t('warning.negativeContent') + ' (' + this.$t('warning.totalCollectedPost') + ')', value: 1},
            {label: this.$t('warning.positiveContent') + ' (' + this.$t('warning.totalCollectedPost') + ')', value: 2},
            {label: this.$t('warning.neutralContent') + ' (' + this.$t('warning.totalCollectedPost') + ')', value: 3},
            {label: this.$t('warning.share') + ' (' + this.$t('warning.ofAArticle') + ')', value: 4},
            {label: this.$t('warning.comment') + ' (' + this.$t('warning.ofAArticle') + ')', value: 5}
        ]
    }
  },
  async created(){
    this.initScreen();
    this.$eventBus.$on('i18n', (event) =>{
        this.initScreen();
        this.refreshI18n();
    })
  }
}
</script>
<style scoped>
.card-filter {
  -webkit-box-shadow: 0px 4px 25px 0px rgb(0 0 0 / 3%)
}
.icon-help {
  vertical-align: text-top;
  width: 14px;
  height: 15px;
  color: black;
}
.space-between {
  justify-content: space-between;
}
.title-warning {
  font-size: 16px;
  font-weight: bold;
  color: #5E5873;
}
.label-warning {
  font-size: 14px;
  font-weight: bold;
  color: #5E5873;
}
.content-active {
  font-size: 12px;
  color: #B9B9C3;
}
.select-mail {
  font-size: 14px;
  color: #6E6B7B;
}
.select-source {
  font-size: 14px;
  color: #9FA2B4;
  white-space: nowrap;
}
</style>
